/** Slugs — keep in sync with `DEFAULT_MODAL_ROUTES` in `modal-routes.ts`. */
export const MODAL_ROUTE_SLUGS = [
    'login',
    'signup',
    'search',
    'cashier',
    'lucky-dip',
    'profile',
    'rewards',
    'freebets'
];
